import $ from 'jquery';
import DataTable from 'datatables.net-bs5';

const unclaimedAmtSenior = {
    methods:{
        createTableHeader:function(headers,tableEl){
            const theadEl = $(tableEl).find('thead'); 
            const tbodyEl = $(tableEl).find('tbody'); 
            theadEl.append(`
            <tr>
            ${
                headers.map((el,idx)=>{
                    return `<th>${el}</th>`
                })
            }
            </tr>
        `)
            tbodyEl.append(`
                <tr>
                ${
                    headers.map((el,idx)=>{
                        return `<th>${el}</th>`
                    })
                }
                </tr>
            `);
        },
        createTableBody:function(tableEl,data,tableHeaders){
            const tbodyEl = $(tableEl).find('tbody');
            $.each(data,(idx,obj)=>{
                tbodyEl.append(`<tr>
                ${
                    tableHeaders.map((el)=>{
                        return `<td>${obj[el]}</td>`
                    })
                }
                </tr>`)
            });
        },
        getResult:function(dataTable,tableEl){
            const inputEl = $(tableEl).closest('.unclaimed-amt-senior__wrapper').find(".unclaimed-amt-senior__input").get(0);
            dataTable = dataTable.rows('tr:first-child').remove(); 
            $(inputEl).on('keyup',function(){
                    dataTable.search($(inputEl).val()) && dataTable.search($(inputEl).val()).draw();
            });
        },
        initializeTable:function(data,tableEl){
            const createTableHead = unclaimedAmtSenior.methods.createTableHeader;
            const createTableBody = unclaimedAmtSenior.methods.createTableBody;
            const addSearch = unclaimedAmtSenior.methods.getResult;
            if(data.length){
                const tempData = data[0];
                const tableHeaders = Object.keys(tempData);
                createTableHead(tableHeaders,tableEl);
                createTableBody(tableEl,data,tableHeaders);
                const dataTable = $(tableEl).DataTable({
                    paging:false,
                    info:false,
                    searching:true,
                    ordering:false,
                    layout:{
                        topEnd:null
                    }
                });
                $(tableEl).find('tbody th').parent().hide();
                $(tableEl).parent().addClass('table-container');
                addSearch(dataTable,tableEl);
            }
        },
        createTableData:function(el){
            const initTable = this.methods.initializeTable;
            const tableEl = $(el).find('table.unclaimed-amt-senior__table').get(0);
            $.ajax({
                url:'/bin/chli/json?path=unclaimedsen',
                dataType:'json'
            }).done((response,status)=>{
                if(status == 'success'){
                    initTable(response,tableEl);
                }
            }).fail(()=>{
                console.log('error occured');
            });
        },
        unclaimedSearchClickedHandler: function(){
                 $('.unclaimed-amt-senior__input').on('focus', function() {
                   let buttonText = $(this).val();
                   let section = $(this).closest('.unclaimed-amt-senior__input');
                   let titleText = section.find('.heading-2').text().trim();
                   let obj = unclaimedAmtSenior.methods.dataLayerObj(buttonText,titleText);
                    createDataLayer('searchClicked',obj);
                 });

            },
            unclaimedSearchKeywordHandler: function() {
                let timeout;

                $('.unclaimed-amt-senior__input').on('keyup', function() {
                    const $this = $(this);
                    clearTimeout(timeout);

                    timeout = setTimeout(function() {
                        let buttonText = $this.val();
                        let section = $this.closest('.unclaimed-amt-senior__input');
                        let titleText = section.find('.heading-2').text().trim();
                        let obj = unclaimedAmtSenior.methods.dataLayerObj(buttonText, titleText);

                        createDataLayer('enter_search_keyword', obj);
                    }, 3000);
                });
            },
        dataLayerObj: function (e,el) {
                            var obj = {
                                'articleName': "",
                                'blogCategory': "",
                                'blogPageCategory': "",
                                'buttonText': "",
                                'pageSection': el ? el : "Unclaimed Amount movement",
                                'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
                                'planOption': "",
                                'productCategory': "",
                                'productName': "",
                                'question': "",
                                'source': "",
                                'searchTerm': e ? e : "",
                                'videoTitle': "",
                                'bannerName': "",
                            };
                            return obj;
                        },

        init:function(){
            const createTable = this.createTableData.bind(unclaimedAmtSenior);
            $('.unclaimed-amt-senior__wrapper').each((idx,el)=>{
                createTable(el);
            });
        }
    }
};


$(()=>{
    unclaimedAmtSenior.methods.init();
    unclaimedAmtSenior.methods.unclaimedSearchClickedHandler();
    unclaimedAmtSenior.methods.unclaimedSearchKeywordHandler();
})